export const fieldRequiredError = (value: string) => {
  if (value === "") {
    return "This field is required";
  }
  return undefined;
};

export const ausPostError = (value: string, country: string) => {
  const lowerCaseCountry = country.toLowerCase();
  if (lowerCaseCountry !== "australia" && lowerCaseCountry !== "au") {
    return undefined;
  }

  if (value.length > 40) {
    return "Must be less than 40 characters. Use additional field below if needed.";
  }
  return undefined;
};
